import ImageHandlerService from "@/modules/file-storage/image-handler.service";

export default function getAttachmentThumbnail(
  url: string,
  imageHandler: ImageHandlerService
) {
  return imageHandler.getThumbnailUrl(url, 200, 200, true);
}
